export const commonMessages = {
  'card.addCart': 'Add to cart',
  'card.added': '✓ Added',
  'card.avg': 'Avg.',
  'card.dash': '—',
  'card.favFail': 'Favorite failed',
  'card.favorites': 'Favorites',
  'card.guestHint': 'Sign in to favorite, rate & add to cart',
  'card.hot': 'Hot',
  'card.officialShop': 'Official store',
  'card.premium': 'Premium',
  'card.rateFail': 'Rating failed',
  'card.rated': 'Rated: ',
  'card.reviews': 'reviews',
  'card.shopDefault': 'Standard shop',
  'card.shopPraise': 'Shop praise',
  'card.tapStars': 'Tap stars to rate',
  'category.dairy': 'Dairy & Beverages',
  'category.freshFruit': 'Fresh Fruits',
  'category.grain': 'Grains & Oils',
  'category.localSpecialty': 'Local Specialties',
  'common.loadFailed': 'Load failed',
  'common.loading': 'Loading…',
  'common.retry': 'Retry',
  'common.yes': 'Yes',
  'common.no': 'No',
  'common.remove': 'Remove',
  'common.back': 'Back',
  'errorBoundary.title': 'Something went wrong',
  'errorBoundary.desc': 'Sorry, an unexpected error occurred. You can try refreshing the page or go back home.',
  'errorBoundary.detail': 'Error details',
  'errorBoundary.reload': 'Reload page',
  'errorBoundary.goHome': 'Go home',
  'credit.crown': 'Crown',
  'credit.diamond': 'Diamond',
  'lang.enUS': 'English',
  'lang.zhCN': 'Chinese',
  'network.offline': 'You are offline. Please check your network connection.',
  'notFound.backHome': 'Back to home',
  'notFound.desc': 'Sorry, the page you visited does not exist',
  'star.1': 'Poor',
  'star.2': 'Fair',
  'star.3': 'OK',
  'star.4': 'Good',
  'star.5': 'Excellent',
};
